import React from "react";
import BoxMetricSettings from "../../containers/Settings/BoxMetricsSettingsPage";
import { Select } from "antd";
import { useState } from "react";
import { Layout } from "antd";

const BoxMetricsSettings = () => {
  const [platform, setPlatform] = useState("Overview");

  const boxMetricPageOptions = [
    {
      value: "Amazon",
      label: "Amazon Executive Summary",
    },
    {
      value: "Shopify",
      label: "Executive Summary",
    },
    {
      value: "Overview",
      label: "Performance Overview",
    },
  ];

  return (
    <Layout.Content
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        padding: "0 24px",
      }}
    >
      <h2>Box Metrics Settings</h2>
      <h3>Select a page</h3>
      <Select
        style={{ width: "15vw" }}
        options={boxMetricPageOptions}
        value={platform}
        onChange={(value) => {
          setPlatform(value);
        }}
      />
      <BoxMetricSettings platform={platform} />
    </Layout.Content>
  );
};

export default BoxMetricsSettings;
